import { ErrorReportingUtils } from '@mm/plugins';
import { SessionObject } from '@mm/state/interfaces/session';
import { selectSessionSelector } from '@mm/state/selectors/userSelector';
import { getIsAutomationFeatureEnabled } from '../selectors/automations';
import { IS_PROD_URL } from '@mm/utils';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const INSTACHAMP_HOTJAR_OPTS = {
  hjid: 2424242,
  hjsv: 6,
};

export const MOBILE_MONKEY_HOTJAR_OPTS = {
  hjid: 2935280,
  hjsv: 6,
};

export interface HotjarOpts {
  hjid: number;
  hjsv: number;
}

function initializeHotjar(opts?: HotjarOpts) {
  const { hjid, hjsv } = opts || {};

  if (!IS_PROD_URL || !hjid || !hjsv) {
    return;
  }

  /* eslint-disable */
  /* tslint:disable */
  // <!-- Hotjar Tracking Code for https://app.mobilemonkey.com/instachamp/ -->
  (function (h, o, t, j, a, r) {
    // @ts-ignore
    h.hj =
      // @ts-ignore
      h.hj ||
      function () {
        // @ts-ignore
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    // @ts-ignore
    h._hjSettings = { hjid, hjsv };
    // @ts-ignore
    a = o.getElementsByTagName('head')[0];
    // @ts-ignore
    r = o.createElement('script');
    // @ts-ignore
    r.async = 1;
    // @ts-ignore
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    // @ts-ignore
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  /* eslint-enable */
}

const hotjarStatus = {
  // We only want to send 'session' level identification once.
  identifyLevel: null as null | 'session' | 'session_and_account',
};

const sendHotjarIdentity = (session: SessionObject, extraArgs: any = {}) => {
  try {
    window.hj?.('identify', session.id || null, {
      name: `${session.firstName} ${session.lastName}`,
      email: session.email,
      ...extraArgs,
    });
  } catch (err) {
    ErrorReportingUtils.captureException(err);
  }
};
export const useHotjar = (opts?: HotjarOpts) => {
  const session = useSelector(selectSessionSelector);

  useEffect(() => {
    if (session && IS_PROD_URL && !hotjarStatus.identifyLevel) {
      hotjarStatus.identifyLevel = 'session';
      sendHotjarIdentity(session);
    }
  }, [session]);

  useEffect(() => initializeHotjar(opts), [opts?.hjid, opts?.hjsv]);
};

export const useHotjarIdentifyAccount = (instagramAccount: string) => {
  const session = useSelector(selectSessionSelector);

  useEffect(() => {
    if (session && instagramAccount && IS_PROD_URL) {
      hotjarStatus.identifyLevel = 'session_and_account';
      sendHotjarIdentity(session, { instagramAccount });
    }
  }, [session, instagramAccount]);
};

export const useHotjarInstachamp = () => {
  useHotjar(INSTACHAMP_HOTJAR_OPTS);
};

export const useHotjarMobileMonkey = () => {
  const automationEnabled = useSelector(getIsAutomationFeatureEnabled);
  const opts = automationEnabled ? MOBILE_MONKEY_HOTJAR_OPTS : undefined;

  useHotjar(opts);
};
